import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 今日考勤信息
  mobilecheckintoday(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/today',
      method: 'get',
      params: args
    })
  },
  // 出勤率
  mobilecheckinrate(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/rate',
      method: 'get',
      params: args
    })
  },
  // 考勤列表
  mobilecheckinlist(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/list',
      method: 'get',
      params: args
    })
  },
  // 在场人数
  countOnSite(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/accessRecord/countOnSite',
      method: 'get',
      params: args
    })
  },
  // 考勤记录
  checkinRecord(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/checkin/pageRecord',
      method: 'get',
      params: args
    })
  },
  personpage(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/person/page',
      method: 'post',
      data: arg
    })
  },
  /**
 * 关键岗位到岗人数
 */
  getKeypostNum(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/getCheckCount',
      method: 'get',
      params: data
    })
  },

  /**
   * 人员类型到岗人数
   */
  getTypepostNum(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/getWorkerManageCount',
      method: 'get',
      params: data
    })
  },
  /**
   * 关键人员考勤
   */
  getKeyCheckPage(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/getCheckPage',
      method: 'post',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/checkinmanage/index.js